import { useTryAccessOnSaleEvent } from 'src/hooks/api/useEventDiscoveryQuota';
import { OnSaleEventPageContentMapAndMetricsWrapper } from 'src/navigations/Routes/OnSaleEvent/OnSaleEventPage';

export const InventoryEventDiscoverySection = ({
  eventId,
}: {
  eventId: number;
}) => {
  useTryAccessOnSaleEvent();

  return (
    <OnSaleEventPageContentMapAndMetricsWrapper tabView eventId={eventId} />
  );
};
